import HttpService from "../../constant/Api";

const API = "v1/document-comment";
const API_ANNOTATION = "v1/annotation";

export const getAnnotationFilesService = (sessionId, hashCode) => {
  return HttpService.get(`${API}/${sessionId}/${hashCode}`);
};

export const postAnnotationFilesService = (
  sessionId,
  hashCode,
  data = {
    clientMessageI: null,
    file: null,
    text: null,
    voiceDuration: 0,
  }
) => {
  return HttpService.post(`${API}/pwa/${sessionId}/${hashCode}`, data);
};

export const savePdfFileService = (fileId, sessionId, annotations) => {
  return HttpService.post(`${API_ANNOTATION}`, {
    annotations: annotations,
    fileId: fileId,
    sessionId: sessionId,
  });
  // {
  //   "annotations": [
  //     {
  //       "currPage": 0,
  //       "referenceHash": "string",
  //       "x": 0,
  //       "y": 0
  //     }
  //   ],
  //   "fileId": "string",
  //   "sessionId": "string"
  // }
};
